import script from "./yhqInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./yhqInfo.vue?vue&type=script&setup=true&lang=js"

import "./yhqInfo.vue?vue&type=style&index=0&id=3918121a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3918121a"]])

export default __exports__